let emergencyTemplateRs: Function;

const emergencyTemplatePromise = new Promise((rs) => {
  emergencyTemplateRs = rs;
});

export {
  emergencyTemplateRs,
  emergencyTemplatePromise,
};
